import {AnyAction} from 'redux'
import {UPDATE_SITE_SETTINGS_OLD, setSiteSettings, updateSiteSettings} from '../actions/site-settings'
import {SiteSettings} from '../types/state'

const defaultState: SiteSettings = {} as SiteSettings

export const siteSettings = (state = defaultState, action: AnyAction): SiteSettings => {
  switch (action.type) {
    case setSiteSettings.toString():
    case UPDATE_SITE_SETTINGS_OLD.SUCCESS:
    case updateSiteSettings.fulfilled.toString():
      return action.payload.settings
    default:
      return state
  }
}
